<template>
  <div class="empty">
    <Empty />
  </div>
</template>
<script>
import {Empty} from "vant";

export default {
  components: {
    Empty
  }
}
</script>

<style scoped lang="scss">
.empty {

}
</style>